import { render, staticRenderFns } from "./RidesItem.vue?vue&type=template&id=28e20e3e&lang=pug&"
import script from "./RidesItem.vue?vue&type=script&lang=js&"
export * from "./RidesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports